import { useMutation, useQueryClient } from '@tanstack/react-query'
import { restaurantsApi } from '@/api/endpoints/restaurants'

export function useCreateRestaurant() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: restaurantsApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['restaurants'] })
    },
  })
}

export function useUpdateRestaurant() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: number
      body: Parameters<typeof restaurantsApi.update>[1]
    }) => restaurantsApi.update(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['restaurants'] })
    },
  })
}
